export enum ImplementationStateStatusValueType {
  implementationStateNew = 'implementationStateNew',
  implementationStateInProgress = 'implementationStateInProgress',
  implementationStateSuspend = 'implementationStateSuspend',
  implementationStateDone = 'implementationStateDone',
  implementationStateChecked = 'implementationStateChecked',
}
